// extracted by mini-css-extract-plugin
module.exports = {"ethAddress":"EthAddress_ethAddress__2l9at","img":"EthAddress_img__3mlq8"};